// const BASE_URL = 'http://3.21.244.222:4000/api';
// const BASE_URL = 'http://3.148.254.56:4000/api'; // new assigned IP
const BASE_URL = 'https://api.olaitools.com/api';
// const BASE_URL = 'http://localhost:4000/api';

export const fetchLtiSessionInfo = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/lti-session-info`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch LTI session info');
        }
        
        const data = await response.json();
        console.log('Front - API - overviewApi - LTI session info data:', data);
        return data;
    } catch (error) {
        console.error("Error fetching LTI session info:", error);
        throw error;
    }
}

export const fetchSubmissionCount = async (start, end, courseId) => {
    console.log("overviewApi - fetchSubmissionCount - start, end, courseId:", start, end, courseId);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        if (courseId) {
            params.append('courseId', courseId);
        }

        const endpoint = courseId
            ? `${BASE_URL}/dashboard/course-submission-count`
            : `${BASE_URL}/dashboard/demo-submission-count`;

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch submission count');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Submission count:', data);
        return data;
    } catch (error) {
        console.error("Error fetching submission count:", error);
        throw error;
    }
};
export const fetchDemoSubmissionCount = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-submission-count${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo submission count');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching demo submission count:", error);
        throw error;
    }
};

export const fetchQuestionAverageByQuiz = async (courseId) => {
    console.log("overviewApi - fetchQuestionAverageByQuiz - courseId:", courseId);
    try {
        const params = new URLSearchParams();
        let endpoint;

        if (courseId) {
            params.append("courseId", courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-average-by-quiz`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-average`;
        }

        const response = await fetch(
            `${endpoint}?${params.toString()}`,
            { credentials: "include" }
        );

        if (!response.ok) {
            throw new Error("Failed to fetch course question average");
        }

        const data = await response.json();
        console.log("Front - API - overviewApi - Course question average:", data);

        // normalize the shape for frontend use
        return (data.quizzes || data).map((row) => ({
            canvasCourseId: row.canvas_course_id,
            quizId: row.quiz_id,
            quizTitle: row.quiz_title,   // <- keep quiz_title
            groupCode: row.group_code,
            avgScore: Number(row.avg_score),
            minScore: Number(row.min_score),
            maxScore: Number(row.max_score),
            stdDev: Number(row.std_dev),
            n: Number(row.n),
        }));
    } catch (error) {
        console.error("Error fetching course question average:", error);
        throw error;
    }
};

export const fetchQuestionAverage = async (start, end, courseId) => {
    console.log("overviewApi - fetchQuestionAverage - start, end, courseId:", start, end, courseId);
    try {
        const params = new URLSearchParams();
        if (start && end) {
            params.append('start', start);
            params.append('end', end);
        }
        let endpoint;                                                           
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-question-average`;     
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-question-average`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch course question average');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Course question average:', data);
        return data;
    } catch (error) {
        console.error("Error fetching course question average:", error);
        throw error;
    }
};
export const fetchDemoQuestionAverage = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/demo-question-average${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo question average');
        }
        const data = await response.json();
        console.log('Front - API - overviewApi - Demo question average:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo question average:", error);
        throw error;
    }
};

export const fetchAllSubmissionDates = async (courseId) => {
    console.log("overviewApi - fetchAllSubmissionDates - courseId:", courseId); 
    try {
        const params = new URLSearchParams();
        let endpoint;

        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/all-course-submission-dates`;
        } else {
            endpoint = `${BASE_URL}/dashboard/all-demo-submission-dates`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch submission dates');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Submission dates:', data);
        return data;
    } catch (error) {
        console.error("Error fetching submission dates:", error);
        throw error;
    }
};
export const fetchAllDemoSubmissionDates = async () => {
    try {
        const response = await fetch(`${BASE_URL}/dashboard/all-demo-submission-dates`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch demo submission dates');
        }

        const data = await response.json();
        console.log('Front - API - overviewApi - Demo submission dates:', data);
        return data;
    } catch (error) {
        console.error("Error fetching demo submission dates:", error);
        throw error;
    }
};

// export const fetchClickTimeRange = async (start, end, courseId) => {
export const fetchClickTimeRange = async (courseId) => {
    // console.log("overviewApi - fetchClickTimeRange - start, end, courseId:", start, end, courseId);
    console.log("overviewApi - fetchClickTimeRange - courseId:", courseId);
    try {
        const params = new URLSearchParams();
        // if (start && end) {
        //     params.append('start', start);
        //     params.append('end', end);
        // }

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/click-timerange-course`;
        } else {
            endpoint = `${BASE_URL}/dashboard/click-timerange`;
        }

        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch click time range');
        }

        const data = await response.json();
        console.log("Click time range", data);
        return data;
    } catch (error) {
        console.error("Error fetching click time range:", error);
        throw error;
    }
};
export const fetchDemoClickTimeRange = async (start, end) => {
    try {
        const query = start && end ? `?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}` : '';
        const response = await fetch(`${BASE_URL}/dashboard/click-timerange${query}`, {
            credentials: 'include'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch demo click time range');
        }
        const data = await response.json();
        console.log("Demo click time range", data);
        return data;
    } catch (error) {
        console.error("Error fetching demo click time range:", error);
        throw error;
    }
}

export const fetchStudentCount = async (courseId) => {
    console.log("overviewApi - fetchStudentCount - courseId:", courseId);
    try {
        const params = new URLSearchParams();

        let endpoint;
        if (courseId) {
            params.append('courseId', courseId);
            endpoint = `${BASE_URL}/dashboard/course-student-count`;
        } else {
            endpoint = `${BASE_URL}/dashboard/demo-student-count`;
        }
        const response = await fetch(`${endpoint}?${params.toString()}`, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user count');
        }

        const data = await response.json();
        console.log("User count:", data);
        return data;
    } catch (error) {
        console.error("Error fetching user count:", error);
        throw error;
    }
};

export const fetchCourseName = async (courseId) => {
    console.log("overviewApi - fetchCourseName - courseId:", courseId);
    if (!courseId) {
        throw new Error('Course ID is required to fetch course name');
    }
    try {
        console.log("Fetching course name for courseId:", courseId);
        const response = await fetch(`${BASE_URL}/dashboard/course-name?courseId=${encodeURIComponent(courseId)}`, {
            credentials: 'include'
        });
        console.log("Response from course name endpoint:", response);

        if (!response.ok) {
            throw new Error('Failed to fetch course name');
        }

        const data = await response.json();
        console.log("Course name:", data.course);
        const course = data.course || {};
        return course.name || "Unknown Course";
    }
    catch (error) {
        console.error("Error fetching course name:", error);
        throw error;
    }
};


